<script>
export default {
    name: 'CalendarMiniDateDay',
    inject: ['$t'],
    props: {
        formattedDate: {
            type: Object,
            required: true
        },
        day: {
            type: Date,
            required: true
        },
        colorDots: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        dots() {
            return this.colorDots.slice(0, 4);
        }
    }
};
</script>

<template>
    <div class="pt-2">
        <div
            class="relative flex h-[50px] cursor-pointer flex-col items-center justify-center rounded-[10px] py-2 text-white"
            :class="[
                day.getDate() === formattedDate.date
                    ? 'bg-blue-dusk cursor-auto'
                    : 'bg-main-secondary-lighter',
                day.getMonth() + 1 === formattedDate.month ? '' : 'bg-base-line'
            ]"
        >
            <div
                v-if="colorDots.length"
                class="absolute -top-1 left-0 flex w-full justify-center"
            >
                <div
                    v-for="(dot, index) in dots"
                    :key="index"
                    class="h-2 w-2 rounded-full last:mr-0"
                    :class="{ 'mr-1': dots.length > 1 }"
                    :style="{ 'background-color': dot }"
                ></div>
            </div>
            <span class="text-md-v4 font-bold">{{ day.getDate() }}</span>
            <span class="mb-1 text-sm">{{
                $t(day.toLocaleDateString('en-US', { weekday: 'short' }))
            }}</span>
        </div>
    </div>
</template>
